'use strict';

export default class MemTypeViewCtrl {
  constructor($stateParams, $state, MemTypeSvc, GroupAuthSvc, LoaderSvc) {
    var that = this;
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // current group
    this.mtId = $stateParams.mtId;

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberType', 'R');

    if(!this.mtId) { return $state.go('group.view.settings.memType.list'); }
    //load memType
    function loadMemType() {
      LoaderSvc.start();
      MemTypeSvc.get({groupId: that.groupId, id: that.mtId}).$promise
        .then(function(memType) {
          that.memType = memType;
          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Member Type');
        });
    }
    loadMemType();
  }
}

MemTypeViewCtrl.$inject = [
  '$stateParams',
  '$state',
  'MemTypeSvc',
  'GroupAuthSvc',
  'LoaderSvc'
];
